export default __webpack_public_path__ + "dcf31621014beaef866fabcb65c26102.png";